<script type="text/javascript">
	import { afterUpdate, onDestroy } from "svelte";
	import Snackbar, {Actions, Label as SBLabel} from '@smui/snackbar';
	import IconButton from '@smui/icon-button';
	import './FormSnackbar.scss';

	export let type = "success"; // success | primary | error | info
	export let text = "";

	let instance;
	let className = "";
	$: {
		text;
		if (type.length > 0) {
			className = "snackbar-" + type;
		} else {
			className = "";
		}
	}

	export function start (withText, andType = "") {
		console.log("Snackbar start", withText, andType);

		text = "";
		instance.close();

		// afterUpdate(()=>{
			text = withText;
			type = andType;
			instance.forceOpen();
		// });
	}

</script>

<Snackbar bind:this={instance} class={className} labelText={text}>
	<SBLabel></SBLabel>
	<Actions>
		<IconButton class="material-icons" title="Dismiss">close</IconButton>
	</Actions>
</Snackbar>
